// メッセージ区分
$(document).on('click', 'input[name="message_type"]', function (e) {
  if ($('input[name="message_type"]:checked').val() == 'none') {
    $('textarea[name="message"]').val('').attr('disabled', true);
    $('.js-messageBox').addClass('is-disabled');
  } else {
    $('textarea[name="message"]').attr('disabled', false);
    $('.js-messageBox').removeClass('is-disabled');
  }
});

// 請求先が違う
$(document).on('click', '.js-check_address', function (e) {
  if ($(this).hasClass('is-match')) {
    $('.js-checkAddressCont').hide();
    $('input[name="i_company"], input[name="i_department"], input[name="i_name"], input[name="i_zip"], input[name="i_pref"], input[name="i_tel"], input[name="i_fax"]').val('');
  } else {
    $('.js-checkAddressCont').show();
  }
});

$(function () {
  $('#datepicker').datepicker({
    changeMonth: true,
    changeYear: true,
    minDate: '+3d',
    maxDate: '+3m',
  });
});
